var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.108,
    height: 26.199,
    viewBox: "0 0 24.108 28.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1661.909 19952.732)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1661.909 -19952.732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0A2,2,0,0,0,0,2V4.666a2,2,0,0,0,2,2H19.33a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2ZM3.333,2.666h4A.667.667,0,0,1,7.332,4h-4a.667.667,0,1,1,0-1.333Zm13.234.569a.333.333,0,0,1,.236-.569h1.056a.333.333,0,0,1,.236.569l-.528.528a.333.333,0,0,1-.472,0ZM2.778,10.665A2.666,2.666,0,0,1,5.445,8h16a2.666,2.666,0,0,1,2.666,2.666v6.666A2.666,2.666,0,0,1,21.442,20h-16a2.666,2.666,0,0,1-2.666-2.666Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,0A2,2,0,0,0,0,2V4.666a2,2,0,0,0,2,2H19.33a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2ZM3.333,2.666h4A.667.667,0,0,1,7.332,4h-4a.667.667,0,1,1,0-1.333Zm13.234.569a.333.333,0,0,1,.236-.569h1.056a.333.333,0,0,1,.236.569l-.528.528a.333.333,0,0,1-.472,0Z",
    transform: "translate(0 21.533)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1667.298 -19941.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.845,12.116a.667.667,0,0,1,.667-.667h12a.667.667,0,0,1,0,1.333h-12A.667.667,0,0,1,5.845,12.116Zm0,5.332a.667.667,0,0,1,.667-.667h8a.667.667,0,0,1,0,1.333h-8A.667.667,0,0,1,5.845,17.449Z",
    transform: "translate(-5.845 -11.449)",
    fill: "#008bff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMenu);
export default __webpack_public_path__ + "static/media/Left Menu.bc8ef1c2eab112731fabe356fbc743ff.svg";
export { ForwardRef as ReactComponent };